import React, { useState } from 'react';
import Button from '../../../audi-ui-components/Button';
import IconCar from '../../../audi-ui-components/icons/Car';
import moment from 'moment';
import { gtmPush } from '../../../lib/gtm';
import _find from 'lodash/find';
import CaretDown from '../../../audi-ui-components/icons/CaretDown';
import CaretUp from '../../../audi-ui-components/icons/CaretUp';
import NavBar from '../../../audi-ui-components/NavBar';
import TickGreen from '../../../audi-ui-components/icons/TickGreen';

const FormatDate = (dateStr) => {
    return moment(dateStr).format('Do MMMM YYYY');
}

const RoadsideAssist = ({ roadsidePolicyDetails }) => {

    const today = moment();

    const [activeTab, setActiveTab] = useState(0);

    const currentPlans = roadsidePolicyDetails?.filter(w =>
        today.isBefore(w.policyEndDate) && today.isAfter(w.policyStartDate)
    ) || [];
    const pastPlans = roadsidePolicyDetails?.filter(w =>
        !(today.isBefore(w.policyEndDate) && today.isAfter(w.policyStartDate))
    ) || [];

    const tabActions = [];
    if (currentPlans.length > 0) tabActions.push({ label: 'Active' });
    if (pastPlans.length > 0) tabActions.push({ label: 'Inactive' });

    const currentTabIndex = currentPlans.length > 0 ? 0 : -1;
    const pastTabIndex = currentPlans.length > 0 && pastPlans.length > 0 ? 1 : (pastPlans.length > 0 ? 0 : -1);

    return (
        <div className="col-12 col-medium-6 pb-3 vehicle-details">
            <div className="aui-color-gray95 mt-3 mb-3 pb-5" style={{ height: '100%' }}>
                <div className="row h-100">

                    <div className="col-12 panel">
                        <div className="py-4">
                            <div className="col-12 px-6">
                                <IconCar />
                            </div>
                            <div className="col-12 px-6">
                                <h2 className="aui-headline-3"><b>Audi Roadside Assistance</b></h2>
                            </div>

                            <div className="col-12 px-6 description">
                                You can drive with the security that one phone call delivers help at any time. 24hrs a day, 7days a week. Call 1800 818 833 for assistance.
                            </div>

                            <div className="col-12 px-6">
                                {(!Array.isArray(roadsidePolicyDetails) || roadsidePolicyDetails.length === 0) && (
                                    <div className="pt-3">No roadside assistance policy found for this vehicle.</div>
                                )}
                                {roadsidePolicyDetails && roadsidePolicyDetails.length > 0 && (
                                    <>
                                        <NavBar
                                            actions={tabActions}
                                            activeIndex={activeTab}
                                            onActionClick={(idx) => setActiveTab(idx)}
                                            navType="tab"
                                            className="recalls-nav mb-4"
                                        />

                                        {activeTab === currentTabIndex && currentPlans.length > 0 && (
                                            <div className="status-group mb-5" style={{ marginTop: '2rem' }}>
                                                {currentPlans.map((w, idx) => {
                                                    const status = 'Active';
                                                    return (
                                                        <div key={'roadside-current-' + idx} className="mt-3 details-accordion">
                                                            <details onToggle={(e) => { if (e.currentTarget.open) gtmPush("myAudi_click", "roadsideassist_accordian", "roadside_history_active"); }}>
                                                                <summary>
                                                                    <div className="title">
                                                                        <span className="label-wrap">
                                                                            <TickGreen small style={{ marginRight: '8px', flexShrink: 0 }} />
                                                                            <span className="label">Assistance Type</span>
                                                                        </span>
                                                                        <span className="value">{w.policyName}</span>
                                                                    </div>
                                                                    <div className="carets">
                                                                        <CaretDown className="down" small />
                                                                        <CaretUp className="up" small />
                                                                    </div>
                                                                </summary>
                                                                <div className="item">
                                                                    <span className="label">Status</span>
                                                                    <span className="value">{status}</span>
                                                                </div>
                                                                <div className="item">
                                                                    <span className="label">Start Date</span>
                                                                    <span className="value">{FormatDate(w.policyStartDate)}</span>
                                                                </div>
                                                                <div className="item pr-5">
                                                                    <span className="label">Expiry Date</span>
                                                                    <span className="value">{FormatDate(w.policyEndDate)}</span>
                                                                </div>
                                                            </details>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}

                                        {activeTab === pastTabIndex && pastPlans.length > 0 && (
                                            <div className="status-group mb-5" style={{ marginTop: '2rem' }}>
                                                {pastPlans.map((w, idx) => {
                                                    const isExpired = today.isAfter(w.policyEndDate);
                                                    const status = isExpired ? 'Expired' : 'Not yet active';
                                                    return (
                                                        <div key={'roadside-past-' + idx} className="mt-3 details-accordion">
                                                            <details onToggle={(e) => { if (e.currentTarget.open) gtmPush("myAudi_click", "roadsideassist_accordian", "roadside_history_inactive"); }}>
                                                                <summary>
                                                                    <div className="title">
                                                                        <span className="label">Assistance Type</span>
                                                                        <span className="value">{w.policyName}</span>
                                                                    </div>
                                                                    <div className="carets">
                                                                        <CaretDown className="down" small />
                                                                        <CaretUp className="up" small />
                                                                    </div>
                                                                </summary>
                                                                <div className="item">
                                                                    <span className="label">Status</span>
                                                                    <span className="value">{status}</span>
                                                                </div>
                                                                <div className="item">
                                                                    <span className="label">Start Date</span>
                                                                    <span className="value">{FormatDate(w.policyStartDate)}</span>
                                                                </div>
                                                                <div className="item pr-5">
                                                                    <span className="label">Expiry Date</span>
                                                                    <span className="value">{FormatDate(w.policyEndDate)}</span>
                                                                </div>
                                                            </details>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                        </div>
                        <div className="">
                            <div className="buttons px-6">
                                <Button variant="primary" className="" href="https://www.audi.com.au/en/owners/roadside-assistance/" target="_blank">Find out more</Button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default RoadsideAssist;
